import React from 'react'
import PropTypes from 'prop-types';

const CalendarField = ({
    icon,
    children,
    extraCssClass = null,
}) => {
    return (
        <div
            className={`trip-field ${extraCssClass !== null ? extraCssClass : ''}`}
        >
            <img src={icon} alt="" className="trip-field__icon" width={20} height={20} />
            <div className="trip-field__content trip-field__content--no-gap">
                {children}
            </div>
        </div>
    )
}

CalendarField.propTypes = {
    icon: PropTypes.string.isRequired,
    extraCssClass: PropTypes.string,
    children: PropTypes.node,
};

export default CalendarField;
